function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "SUBSCRIBED_DOCUMENTS_",
  "data-name": "SUBSCRIBED DOCUMENTS'",
  transform: "translate(-43.9 -555.9)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_114",
  "data-name": "Group 114",
  transform: "translate(45 556)"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_Document_3024619",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_112",
  "data-name": "Group 112",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_310",
  "data-name": "Path 310",
  d: "M186.274,104.126H175.151A1.153,1.153,0,0,1,174,102.975V87.151A1.153,1.153,0,0,1,175.151,86h7.533l4.74,4.74v12.235A1.153,1.153,0,0,1,186.274,104.126ZM175.151,86.638a.513.513,0,0,0-.513.513v15.824a.513.513,0,0,0,.513.513h11.123a.513.513,0,0,0,.513-.513V91l-4.366-4.366Z",
  transform: "translate(-175 -86)",
  fill: "#222",
  stroke: "#222",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_38",
  "data-name": "Rectangle 38",
  width: 8,
  height: 0.8,
  rx: 0.4,
  transform: "translate(1 8)",
  fill: "#222",
  stroke: "#222",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_39",
  "data-name": "Rectangle 39",
  width: 5,
  height: 0.8,
  rx: 0.4,
  transform: "translate(1 10.243)",
  fill: "#222",
  stroke: "#222",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_42",
  "data-name": "Rectangle 42",
  width: 2,
  height: 0.8,
  rx: 0.4,
  transform: "translate(1 14.7)",
  fill: "#222",
  stroke: "#222",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_40",
  "data-name": "Rectangle 40",
  width: 7,
  height: 0.8,
  rx: 0.4,
  transform: "translate(1 12.486)",
  fill: "#222",
  stroke: "#222",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_311",
  "data-name": "Path 311",
  d: "M611.872,105.872h-3.783A1.091,1.091,0,0,1,607,104.783V101h.638v3.783a.451.451,0,0,0,.451.451h3.783Z",
  transform: "translate(-599.767 -100.681)",
  fill: "#222",
  stroke: "#222",
  strokeWidth: 0.2
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_115",
  "data-name": "Group 115",
  transform: "translate(52.467 565.668)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_41",
  "data-name": "Rectangle 41",
  width: 8.099,
  height: 7.499,
  rx: 0.5,
  transform: "translate(1.523 1.842)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  id: "noun_rss_feed_318007",
  "data-name": "noun_rss feed_318007",
  transform: "matrix(1, -0.017, 0.017, 1, 0, 0.189)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_312",
  "data-name": "Path 312",
  d: "M9.221,1.187,1.672.005a.426.426,0,0,0-.485.354L.005,7.908a.426.426,0,0,0,.354.485L7.908,9.575a.426.426,0,0,0,.485-.354L9.575,1.672A.426.426,0,0,0,9.221,1.187ZM7.349,8.3a1.007,1.007,0,1,1,.22-1.407A1.005,1.005,0,0,1,7.349,8.3Zm.788-3.14a.609.609,0,0,1-.7.507A2.305,2.305,0,0,0,4.814,7.583a.609.609,0,1,1-1.2-.188A3.513,3.513,0,0,1,7.63,4.463.609.609,0,0,1,8.137,5.159Zm.325-2.065a.611.611,0,0,1-.7.509A4.389,4.389,0,0,0,2.751,7.26a.611.611,0,1,1-1.207-.189A5.61,5.61,0,0,1,7.953,2.4.611.611,0,0,1,8.462,3.094Z",
  transform: "translate(0 1.333) rotate(-8)",
  fill: "#222"
}))));

var SvgSubscribedDocuments = function SvgSubscribedDocuments(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.551,
    height: 20.753,
    viewBox: "0 0 19.551 20.753",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSubscribedDocuments, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SubscribedDocuments.2ed0803f.svg";
export { ForwardRef as ReactComponent };